import pages from "../pages/index";

const routes = [
  // Operators
  {
    resource: "operator",
    path: "operator",
    element: pages.Operators,
    children: [
      { path: "new", element: pages.CreateOperator },
      { path: ":id", element: pages.EditOperator },
    ],
  },

  // Company
  {
    resource: "company",
    path: "company",
    element: pages.Company,
    children: [
      { path: "new", element: pages.CreateCompany },
      { path: ":id", element: pages.EditCompany },
    ],
  },

  // Campaign
  {
    resource: "campaign",
    path: "campaign",
    element: pages.Campaign,
    children: [
      {
        path: "new",
        element: pages.CreateCampaign,
      },
      {
        path: ":id",
        element: pages.EditCampaign,
      },
    ],
  },
  // POS
  {
    resource: "pos",
    path: "pos",
    element: pages.POS,
    children: [
      { path: "new", element: pages.NewPOS },
      { path: ":id", element: pages.PosAllocation },
    ],
  },

  //   Member
  {
    resource: "member",
    path: "member",
    element: pages.Member,
    children: [
      // {
      //   path: "change-password/:id",
      //   element: pages.ChangePassword,
      // },
      {
        path: "new",
        element: pages.CreateMember,
      },
      {
        path: ":id",
        element: pages.EditMember,
      },
      {
        path: "mass-upload",
        element: pages.MassUpload,
      },
      { path: "wallet/:id", element: pages.Wallet },
    ],
  },
  // Acceptance Points
  {
    resource: "acceptance-point",
    path: "acceptance-point",
    element: pages.AcceptancePoints,
    children: [
      { path: "new", element: pages.CreateAcceptancePoint },
      { path: ":id", element: pages.EditAcceptancePoint },
    ],
  },
  // Billing
  // {
  //   resource: "billing",
  //   path: "billing",
  //   element: pages.Billing,
  //   children: [
  //     { path: "payment-profile", element: pages.PaymentProfile },
  //     { path: "payment-profile/update", element: pages.NewCard },
  //     { path: "invoices", element: pages.Invoices },
  //   ],
  // },
  // Transactions
  {
    resource: "transaction",
    path: "transaction",
    element: pages.Transaction,
    children: [],
  },
  // Report
  // {
  //   resource: "transaction",
  //   path: "report",
  //   element: pages.DailyReport,
  //   children: [
  //     { path: "daily", element: pages.DailyReport },
  //     { path: "monthly", element: pages.MonthlyReport },
  //   ],
  // },
  // User Management
  {
    resource: "user",
    path: "user",
    element: pages.User,
    children: [
      {
        path: "new",
        element: pages.CreateUser,
      },
    ],
  },
];

export default routes;
